// extracted by mini-css-extract-plugin
module.exports = {"qNaContaienr":"_3xvww1fUX00fvH54VtqGMc","qnaText":"PRvD6Z9DahkkxwVexg6BL"};